import React from 'react'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Typography from '@mui/material/Typography'
import { SX } from '../constants'

type Props = {
  onClose: () => void
}

// Shown only when no record types (and no knock statuses) are selected. The
// "No results found for the applied filters." message was removed per product
// (SH-858); this select-record-types warning stays.
export const AlertMessage = ({ onClose }: Props) => (
  <Alert
    severity="info"
    onClose={onClose}
    sx={{ ...SX.alert, ...SX.alertWidth }}
  >
    <AlertTitle sx={SX.alertTitle}>No record types selected.</AlertTitle>
    <Typography variant="body2">
      You must select at least one record type in the filters to view records on
      the map.
    </Typography>
  </Alert>
)
